export default {
  tokenEndpoint: 'https://asia-southeast2-tcaster-push-notifications.cloudfunctions.net/api/token',
  pushV1Endpoint: 'https://backoffice-api.tcaster.net/notifications/api/Push/push/',
  pushV2Endpoint: 'https://backoffice-api.tcaster.net/notifications/api/Push/push2',
};
